import React from 'react';

const Toast = ({ message, type, onClose }) => {
  const toastColors = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    warning: 'bg-yellow-500',
    info: 'bg-blue-500',
  };

  return (
    <div className={`fixed top-5 right-5 flex items-start ${toastColors[type]} text-white px-3 py-3 rounded-xl shadow-lg w-80 max-w-full break-words`}>
      <div className="flex-1">
        <p>{message}</p>
      </div>
      <button
        className="ml-4 text-white font-bold"
        onClick={onClose}
      >
        ✖
      </button>
    </div>
  );
};

export default Toast;